<template>
  <div>
    <Card shadow>
      <Row :gutter="20">
        <i-col>
          <span>节点选择：  </span>
          <i-select  style="width: 28%;min-width: 236px;" @on-change="handleNodeOnChange">
            <i-option v-for="item in nodeArray" :value="item.name" :key="item.name" :label="item.name"></i-option>
          </i-select>
        </i-col>
      </Row>
      <Row :gutter="20" style="margin-top: 10px;">
        <i-col :md="24" :lg="12" style="margin-bottom: 20px;">
          <Card shadow>
            <chart-pie style="height: 300px;" :value="pieDataNodeCpu" text="节点cpu使用情况"></chart-pie>
          </Card>
        </i-col>
        <i-col :md="24" :lg="12" style="margin-bottom: 20px;">
          <Card shadow>
            <chart-pie style="height: 300px;" :value="pieDataNodeMem" text="节点内存使用情况"></chart-pie>
          </Card>
        </i-col>
      </Row>
      <Row :gutter="20" style="margin-top: 30px;">
      <i-col>
          <span>Pod选择：  </span>
          <i-select  style="width: 28%;min-width: 236px;" @on-change="handlePodOnChange">
            <i-option v-for="item in podArray" :value="item.name" :key="item.name" :label="item.name"></i-option>
          </i-select>
        </i-col>
      </Row>
      <Row :gutter="20" style="margin-top: 10px;">
        <i-col :md="24" :lg="12" style="margin-bottom: 20px;">
          <Card shadow>
            <!-- <chart-pie style="height: 300px;" :value="pieDataPodCpu" text="Pod cpu使用情况"></chart-pie> -->
            <chart-bar style="height: 300px;" :value="pieDataPodCpu" text="Pod cpu使用情况(m)"/>
          </Card>
        </i-col>
        <i-col :md="24" :lg="12" style="margin-bottom: 20px;">
          <Card shadow>
            <!-- <chart-pie style="height: 300px;" :value="pieDataPodMem" text="Pod内存使用情况"></chart-pie> -->
            <chart-bar style="height: 300px;" :value="pieDataPodMem" text="Pod内存使用情况(Mi)"/>
          </Card>
        </i-col>
        <!-- <Card>
          <Row type="flex" justify="center" align="middle" class="countto-page-row">
            <div class="count-to-con">
              <count-to :simplify="true" :unit="unit" :end="podCpu" count-class="count-text" unit-class="unit-class">
                <span class="slot-text" slot="left">pod Cpu使用：</span>
              </count-to>
              <count-to :simplify="true" :unit="unit" :end="podMem" count-class="count-text" unit-class="unit-class">
                <span class="slot-text" slot="left">pod 内存使用：</span>
              </count-to>
            </div>
          </Row>
        </Card> -->
      </Row>
    </Card>
  </div>
</template>

<script>
import InforCard from '_c/info-card'
import CountTo from '_c/count-to'
import { ChartPie, ChartBar } from '_c/charts'
import { getNodeList, getNodeUse, getPodList, getPodUse } from '@/api/cloud'
export default {
  name: 'NodeDashboard',
  components: {
    InforCard,
    CountTo,
    ChartPie,
    ChartBar
  },
  data () {
    return {
      nodeArray: [],
      podArray: [],
      nodeSel: null,
      podSel: null,
      nodeCpu: null,
      cpuUse: 20,
      memUse: 310,
      podCpu: 0,
      podMem: 0,
      pieDataNodeCpu: [],
      pieDataNodeMem: [],
      pieDataPodCpu: {},
      pieDataPodMem: {}
    }
  },
  methods: {
    getNodeList () {
      getNodeList().then(res => {
        this.nodeArray = res.data
      })
    },
    getPodList () {
      getPodList().then(res => {
        this.podArray = res.data
      })
    },
    handleNodeOnChange (value) {
      this.getNodeUse(value)
      this.getPodList(value)
    },
    handlePodOnChange (value) {
      this.getPodUse(value)
    },
    getNodeUse (value) {
      let that = this
      that.pieDataNodeCpu = []
      that.pieDataNodeMem = []
      // 读取选择节点的 使用情况
      getNodeUse(value).then(res => {
        let valueCpu1 = { value: res.data.cpu_usage, name: '已使用(m)' }
        let valueCpu2 = { value: res.data.free_cpu, name: '空闲(m)' }
        let valueMem1 = { value: res.data.mem_usage, name: '已使用(Mi)' }
        let valueMem2 = { value: res.data.free_mem, name: '空闲(Mi)' }
        that.pieDataNodeCpu.push(valueCpu1)
        that.pieDataNodeCpu.push(valueCpu2)
        that.pieDataNodeMem.push(valueMem1)
        that.pieDataNodeMem.push(valueMem2)
      })
    },
    // 得到当前选择的Node的相关pod监控情况
    getPodUse (value) {
      let that = this
      that.pieDataPodCpu = {}
      that.pieDataPodMem = {}
      // 读取选择节点的 使用情况
      getPodUse(value).then(res => {
        let key1 = res.data.time
        let cpuData = {}
        let menData = {}
        cpuData[key1] = res.data.cpu_usage
        menData[key1] = res.data.mem_usage
        that.pieDataPodCpu = cpuData
        that.pieDataPodMem = menData
      })
    }
  },
  mounted () {
    this.getNodeList()
    this.getPodList()
  }
}
</script>

<style lang="less" scoped>
.count-style{
  font-size: 50px;
}
@baseColor: ~"#dc9387";
.countto-page-row{
  height: 200px;
}
.count-to-con{
  display: block;
  width: 100%;
  text-align: center;
}
.count-text{
  font-size: 50px;
  color: @baseColor;
}
.slot-text{
  font-size: 22px;
}
.unit-class{
  font-size: 30px;
  color: @baseColor;
}
</style>
